import type { GaVueComponent } from "@/common/vueUtils";

export const GaFormFieldLabel = (props: { name: string; required?: boolean; label?: string | GaVueComponent }): GaVueComponent => {
  if (props.label === undefined) {
    return <></>;
  }
  if (typeof props.label === "string" && props.label.trim().length > 0) {
    return (
      <label for={props.name} class="form-label">
        {props.label} {props.required === true ? <span>*</span> : null}
      </label>
    );
  }
  return (
    <label for={props.name} class="form-label">
      {props.label} {props.required === true ? <span>*</span> : null}
    </label>
  );
};
